export const filterMap = Object.freeze({
  BRAND_HILLS_TREATS: 'Brand_HillsTreats',
  BRAND_PRESCRIPTION_DIET: 'Brand_PrescriptionDiet',
  BRAND_SCIENCE_DIET: 'Brand_ScienceDiet',
  BRAND_VET_ESSENTIALS: 'Brand_VetEssentials',
  SIZE_LARGE_DOG: 'BreedSize_LargeDog',
  SIZE_MEIDUM_DOG: 'BreedSize_MediumDog',
  SIZE_SMALL_DOG: 'BreedSize_SmallDog',
  CATEGORY_CANCER: 'Category_Cancer',
  CATEGORY_DENTAL: 'Category_Dental',
  CATEGORY_DERM: 'Category_Derm',
  CATEGORY_GASTROINTESTINAL: 'Category_Gastrointestinal',
  CATEGORY_KIDNEY: 'Category_Kidney',
  CATEGORY_MOBILITY: 'Category_Mobility',
  CATEGORY_TREATS: 'Category_Treats',
  CATEGORY_URINARY: 'Category_Urinary',
  CATEGORY_WEIGHT: 'Category_Weight',
  FLAVOR_BEEF: 'Flavor_Beef',
  FLAVOR_CHICKEN: 'Flavor_Chicken',
  FLAVOR_DUCK: 'Flavor_Duck',
  FLAVOR_EGG: 'Flavor_Egg',
  FLAVOR_LAMB: 'Flavor_Lamb',
  FLAVOR_LIVER: 'Flavor_Liver',
  FLAVOR_OCEANFISH: 'Flavor_OceanFish',
  FLAVOR_ORIGINAL: 'Flavor_OriginalFlavor',
  FLAVOR_POLLOCK: 'Flavor_Pollock',
  FLAVOR_SALMON: 'Flavor_Salmon',
  FLAVOR_TUNA: 'Flavor_Tuna',
  FLAVOR_TURKEY: 'Flavor_Turkey',
  FLAVOR_VEGETABLE: 'Flavor_Vegetable',
  FLAVOR_VENISON: 'Flavor_Venison',
  FOOD_TYPE_CANNED: 'FoodType_Canned',
  FOOD_TYPE_DRY: 'FoodType_Dry',
  FOOD_TYPE_POUCHES: 'FoodType_Pouches',
  FOOD_TYPE_TRAY: 'FoodType_Tray',
  FOOD_TYPE_TREATS: 'FoodType_Treats',
  LIFESTAGE_ADULT_CAT_FOOD: 'Lifestage_AdultCatFood',
  LIFESTAGE_ADULT_DOG_FOOD_1TO6_YEARS: 'Lifestage_AdultDogFood1To6Years',
  LIFESTAGE_KITTEN_FOOD: 'Lifestage_KittenFood',
  LIFESTAGE_PUPPY_FOOD_LESS_THAN_1_YEAR: 'Lifestage_PuppyFoodLessThan1 Year',
  LIFESTAGE_SENIOR_CAT_FOOD: 'Lifestage_SeniorCatFood',
  LIFESTAGE_SENIOR_DOG_FOOD_MORE_THAN_7_YEARS:
    'Lifestage_SeniorDogFoodMoreThan7Years',
  OTHER_FAVORITES: 'Other_Favorites',
  OTHER_NEW_PRODUCTS: 'Other_NewProducts',
  SPECIES_CAT: 'Species_Cat',
  SPECIES_DOG: 'Species_Dog',
});

export const defaultFilterSetup = Object.freeze(
  Object.fromEntries(
    Object.keys(filterMap).map((key) => [key, { key, enabled: false }])
  )
);

export const reverseFilterMap = Object.freeze(
  Object.fromEntries(Object.entries(filterMap).map(([k, v]) => [v, k]))
);

export const baseFilterFunctionMap = Object.fromEntries(
  Object.entries(filterMap).map(([filterKey, tag]) => {
    return [[filterKey], (product) => product.tags.includes(tag)];
  })
);

export const filterGroups = Object.freeze({
  SPECIES: [filterMap.SPECIES_CAT, filterMap.SPECIES_DOG],
  DISPLAY: [filterMap.OTHER_FAVORITES],
  BRAND: [
    filterMap.BRAND_HILLS_TREATS,
    filterMap.BRAND_PRESCRIPTION_DIET,
    filterMap.BRAND_SCIENCE_DIET,
    filterMap.BRAND_VET_ESSENTIALS,
  ],
  SPECIAL_DIET: [
    filterMap.CATEGORY_CANCER,
    filterMap.CATEGORY_DENTAL,
    filterMap.CATEGORY_DERM,
    filterMap.CATEGORY_GASTROINTESTINAL,
    filterMap.CATEGORY_KIDNEY,
    filterMap.CATEGORY_MOBILITY,
    filterMap.CATEGORY_WEIGHT,
    filterMap.CATEGORY_URINARY,
  ],
  LIFESTAGE: [
    filterMap.LIFESTAGE_ADULT_CAT_FOOD,
    filterMap.LIFESTAGE_ADULT_DOG_FOOD_1TO6_YEARS,
    filterMap.LIFESTAGE_KITTEN_FOOD,
    filterMap.LIFESTAGE_PUPPY_FOOD_LESS_THAN_1_YEAR,
    filterMap.LIFESTAGE_SENIOR_CAT_FOOD,
    filterMap.LIFESTAGE_SENIOR_DOG_FOOD_MORE_THAN_7_YEARS,
  ],
  PRODUCT_TYPE: [
    filterMap.FOOD_TYPE_CANNED,
    filterMap.FOOD_TYPE_DRY,
    filterMap.FOOD_TYPE_POUCHES,
    filterMap.FOOD_TYPE_TRAY,
    filterMap.FOOD_TYPE_TREATS,
  ],
  FLAVOR: [
    filterMap.FLAVOR_BEEF,
    filterMap.FLAVOR_CHICKEN,
    filterMap.FLAVOR_DUCK,
    filterMap.FLAVOR_EGG,
    filterMap.FLAVOR_LAMB,
    filterMap.FLAVOR_LIVER,
    filterMap.FLAVOR_OCEANFISH,
    filterMap.FLAVOR_ORIGINAL,
    filterMap.FLAVOR_POLLOCK,
    filterMap.FLAVOR_SALMON,
    filterMap.FLAVOR_TUNA,
    filterMap.FLAVOR_TURKEY,
    filterMap.FLAVOR_VEGETABLE,
    filterMap.FLAVOR_VENISON,
  ],
});

export const reverseSectionMap = {};

Object.entries(filterGroups).forEach(([k, v]) => {
  v.forEach((filterKey) => {
    reverseSectionMap[filterKey] = k;
  });
});

export const sectionFilterInclusivity = Object.freeze({
  SPECIES: 'exclusive',
  DISPLAY: 'inclusive',
  BRAND: 'inclusive',
  SPECIAL_DIET: 'inclusive',
  LIFESTAGE: 'inclusive',
  PRODUCT_TYPE: 'inclusive',
  FLAVOR: 'inclusive',
});

export const queryParamResolver = Object.fromEntries(
  Object.keys(filterGroups).map((key) => {
    const lowercaseKey = key.toLowerCase();
    const options = filterGroups[key].map((field) => {
      return {
        originalKey: key,
        originalField: Object.entries(filterMap).find(
          ([_, v]) => v === field
        )?.[0],
        field: field
          .split('_')
          .slice(1)
          .join('_')
          .replace(/[A-Z]/g, (m, idx) =>
            idx === 0 ? m.toLowerCase() : '-' + m.toLowerCase()
          )
          .replace(/ /g, '-'),
      };
    });
    return [lowercaseKey, options];
  })
);
